/* @flow */
import { ActionTypes } from '../constants/ConnectedBankAccountConstants';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';
import ConnectedBankAccounts from 'collections/ConnectedBankAccounts';
import { dispatcher } from 'lib/Dispatcher';
import API from 'lib/RemindAPI';

const ConnectedBankAccountActions = {
  requestAccess() {
    return ConnectedBankAccount.requestAccess(...arguments).then(account => {
      dispatcher.dispatch({
        type: ActionTypes.CREATE_CONNECTED_BANK_ACCOUNT,
        connectedBankAccount: account,
      });
      return account;
    });
  },

  load() {
    return ConnectedBankAccounts.load().then(connectedBankAccounts => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_CONNECTED_BANK_ACCOUNTS,
        connectedBankAccounts,
      });

      return connectedBankAccounts;
    });
  },

  getConnectedBankAccount(accessToken: string) {
    return ConnectedBankAccount
      .getConnectedBankAccount(accessToken)
      .then(connectedBankAccount => {
        dispatcher.dispatch({
          type: ActionTypes.GET_CONNECTED_BANK_ACCOUNT,
          connectedBankAccount,
        });
        return connectedBankAccount;
      });
  },

  reject(connectedBankAccountUUID: string) {
    API.request(`/payments/connected_bank_accounts/${connectedBankAccountUUID}/reject`, 'POST').then(() => {
      dispatcher.dispatch({
        type: ActionTypes.REJECT,
        connectedBankAccountUUID,
      });
    });
  },

  // $FlowFixMe TODO
  approve(token, bankAccountName, accessToken, connectedBankAccountId) {
    return ConnectedBankAccount
      .approve(token, bankAccountName, accessToken, connectedBankAccountId)
      .then(connectedBankAccount => {
        dispatcher.dispatch({
          type: ActionTypes.APPROVE,
          connectedBankAccount,
        });
        return connectedBankAccount;
      });
  },

  revokeAccess(account: ConnectedBankAccount) {
    return account.revokeAccess().then(connectedBankAccount => {
      dispatcher.dispatch({
        type: ActionTypes.REVOKE_ACCESS,
        connectedBankAccount,
      });
      return connectedBankAccount;
    });
  },
};

export default ConnectedBankAccountActions;



// WEBPACK FOOTER //
// ./src/payments/actions/ConnectedBankAccountActions.js